import { filter } from 'ramda';

const cleanCondition = (val) => val !== null && val !== undefined && val !== '';

export const cleanObj = (obj) => filter(cleanCondition, obj || {});

export const getKeyByValue = (obj, value) => Object.keys(obj).find((key) => obj[key] === value);
